<div class="header">
    <div class="row">
        <div class="col-6 detail-header-left">
            <h2>Dettaglio <strong>Pratica</strong></h2>
            <span class="request-id-badge" *ngIf="request?.IDRequest">ID {{ request.IDRequest }}</span>
            <div class="detail-header-actions" *ngIf="user.FKIDUserRole === 1">
                <a [routerLink]="['/richiesta/modifica/' + request.IDRequest]" class="btn btn-xs btn-primary detail-action-btn"><i class="fa fa-pencil"></i><span>Modifica</span></a>
                <a (click)="openDeleteRequestModal()" class="btn btn-xs btn-danger detail-action-btn"><i class="fa fa-trash-o"></i><span>Elimina</span></a>
            </div>
        </div>
        <div class="col-4" style="text-align: right; margin-top: 10px;">
            <ol class="breadcrumb">
                <li><a style="cursor: pointer;" [routerLink]="['/dashboard']">Pratiche</a></li>
                <li class="active">Dettaglio Pratica</li>
            </ol>
        </div>
    </div>
</div>

<div class="view-switcher" *ngIf="canShowDnsView || canShowIperView" role="tablist" aria-label="Viste della pratica">
    <button type="button"
            role="tab"
            class="view-tab"
            [class.active]="activeView === 'base'"
            [attr.aria-selected]="activeView === 'base'"
            (click)="setView('base')">
        <i class="fa fa-th-list"></i>
        <span>Vista Base</span>
    </button>
    <button type="button"
            *ngIf="canShowDnsView"
            role="tab"
            class="view-tab"
            [class.active]="activeView === 'dns'"
            [attr.aria-selected]="activeView === 'dns'"
            (click)="setView('dns')">
        <i class="fa fa-file-text-o"></i>
        <span>Vista Domanda Nuova Sabatini</span>
    </button>
    <button type="button"
            *ngIf="canShowIperView"
            role="tab"
            class="view-tab"
            [class.active]="activeView === 'iper'"
            [attr.aria-selected]="activeView === 'iper'"
            (click)="setView('iper')">
        <i class="fa fa-industry"></i>
        <span>Vista Iperammortamento 4.0</span>
    </button>
</div>

<div class="row">
    <div class="col-12" *ngIf="activeView === 'dns' && canShowDnsView">
        <app-request-dns-view [request]="request"></app-request-dns-view>
    </div>
    <div class="col-12" *ngIf="activeView === 'iper' && canShowIperView">
        <app-request-iper-view [request]="request"></app-request-iper-view>
    </div>
    <div class="col-md-5 col-12" *ngIf="activeView === 'base'">
        <div class="panel">
            <div class="panel-header panel-controls bg-dark">
                <h3><i class="fa fa-list"></i>Informazioni <strong>Pratica</strong></h3>
            </div>
            <div class="panel-content detail-panel">
                <div class="detail-section">
                    <div class="detail-section-title">Pratica</div>
                    <div class="detail-field detail-field-id">
                        <span class="detail-label">ID Pratica</span>
                        <span class="detail-value">{{ request?.IDRequest ?? '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data Creazione</span>
                        <span class="detail-value">{{ request?.CreationDate ? (request?.CreationDate | date: 'dd/MM/yyyy HH:mm') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">E-mail</span>
                        <span class="detail-value">{{ displayValue(request?.Email) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Gestione Interna</span>
                        <span class="detail-value">{{ request?.InternalManagement ? 'Sì' : 'No' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Stato</span>
                        <span class="detail-value">
                            <span *ngIf="request?.ProgressStatus != null && request.ProgressStatus < 9" class="badge badge-progress">In fase di compilazione</span>
                            <span *ngIf="request?.ProgressStatus === 9 && !request.CompanyParticipation && !request.PartnersParticipation" class="badge badge-info">Da convalidare</span>
                            <span *ngIf="request?.ProgressStatus === 9 && (request.CompanyParticipation || request.PartnersParticipation)" class="badge badge-warning">Da controllare</span>
                            <span *ngIf="request?.ProgressStatus === 10" class="badge badge-success">Completato</span>
                            <span *ngIf="request?.ProgressStatus == null">-</span>
                        </span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Segnalatori</span>
                        <span class="detail-value">
                            <span *ngIf="signalParties.length; else noReferrers" class="party-list">
                                <ng-container *ngFor="let party of signalParties">
                                    <a *ngIf="user.FKIDUserRole === 1"
                                       class="party-badge"
                                       [class.party-badge-supplier]="party.kind === 'supplier'"
                                       [routerLink]="party.link">
                                        <span class="party-badge-kind">{{ party.kindLabel }}</span>
                                        <span class="party-badge-name">{{ party.label }}</span>
                                    </a>
                                    <span *ngIf="user.FKIDUserRole !== 1"
                                          class="party-badge"
                                          [class.party-badge-supplier]="party.kind === 'supplier'">
                                        <span class="party-badge-kind">{{ party.kindLabel }}</span>
                                        <span class="party-badge-name">{{ party.label }}</span>
                                    </span>
                                </ng-container>
                            </span>
                            <ng-template #noReferrers>-</ng-template>
                        </span>
                    </div>
                    <div class="detail-field detail-field-block" *ngIf="user.FKIDUserRole === 1 && hasPaymentDetails">
                        <span class="detail-label">Informazioni Costi</span>
                        <span class="detail-value">{{ request?.PaymentDetails }}</span>
                    </div>
                    <div class="detail-field" *ngIf="user.FKIDUserRole === 1 && !hasPaymentDetails">
                        <span class="detail-label">Costi DNS</span>
                        <span class="detail-value detail-value-money">
                            <ng-container *ngIf="request?.PaymentCost1 != null && request.PaymentCost1 !== 0; else paymentCost1Empty">
                                {{ request.PaymentCost1 | currency:'EUR':'':'1.2-2':'it-IT' }} euro
                            </ng-container>
                            <ng-template #paymentCost1Empty>-</ng-template>
                        </span>
                    </div>
                    <div class="detail-field" *ngIf="user.FKIDUserRole === 1 && !hasPaymentDetails">
                        <span class="detail-label">Costi Iperammortamento 4.0</span>
                        <span class="detail-value detail-value-money">
                            <ng-container *ngIf="request?.PaymentCost2 != null && request.PaymentCost2 !== 0; else paymentCost2Empty">
                                {{ request.PaymentCost2 | currency:'EUR':'':'1.2-2':'it-IT' }} euro
                            </ng-container>
                            <ng-template #paymentCost2Empty>-</ng-template>
                        </span>
                    </div>
                    <div class="detail-field" *ngIf="user.FKIDUserRole === 1 && !hasPaymentDetails">
                        <span class="detail-label">Costo Perizia</span>
                        <span class="detail-value detail-value-money">
                            <ng-container *ngIf="request?.PaymentCostExpertise != null && request.PaymentCostExpertise !== 0; else paymentCostExpertiseEmpty">
                                {{ request.PaymentCostExpertise | currency:'EUR':'':'1.2-2':'it-IT' }} euro
                            </ng-container>
                            <ng-template #paymentCostExpertiseEmpty>-</ng-template>
                        </span>
                    </div>
                    <div class="detail-field" *ngIf="user.FKIDUserRole === 1 && !hasPaymentDetails">
                        <span class="detail-label">Costo Certificazione Contabile</span>
                        <span class="detail-value detail-value-money">
                            <ng-container *ngIf="request?.PaymentCostCertification != null && request.PaymentCostCertification !== 0; else paymentCostCertificationEmpty">
                                {{ request.PaymentCostCertification | currency:'EUR':'':'1.2-2':'it-IT' }} euro
                            </ng-container>
                            <ng-template #paymentCostCertificationEmpty>-</ng-template>
                        </span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Tipologia Pratica</span>
                        <span class="detail-value">{{ displayValue(request?.request_type?.RequestType) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Pratica semplificata</span>
                        <span class="detail-value">{{ request?.Simplified ? 'Sì' : 'No' }}</span>
                    </div>
                </div>

                <div class="detail-section">
                    <div class="detail-section-title">Società / Ditta Individuale</div>
                    <div class="detail-field">
                        <span class="detail-label">Ragione Sociale</span>
                        <span class="detail-value detail-value-with-action">
                            <span>{{ displayValue(request?.customer?.CompanyName) }}</span>
                            <a *ngIf="request?.customer?.IDCustomer || request?.FKIDCustomer"
                               [routerLink]="['/clienti/' + (request?.customer?.IDCustomer || request?.FKIDCustomer)]"
                               class="btn btn-xs btn-info detail-action-btn">
                                <i class="fa fa-user"></i><span>Dettaglio Cliente</span>
                            </a>
                        </span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Partita IVA</span>
                        <span class="detail-value">{{ displayValue(request?.customer?.VATNumber) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Sede Legale</span>
                        <span class="detail-value">{{ displayPlace(request?.customer?.HeadOffice, request?.customer?.HeadOfficeProvince) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Via e Civico</span>
                        <span class="detail-value">{{ customerAddressDisplay }}</span>
                    </div>
                    <div class="detail-field" *ngIf="request?.FKIDRequestType !== 5">
                        <span class="detail-label">IBAN</span>
                        <span class="detail-value">{{ displayValue(request?.customer?.IBAN) }}</span>
                    </div>
                    <div class="detail-field" *ngIf="request?.FKIDRequestType !== 5">
                        <span class="detail-label">Banca di Appoggio</span>
                        <span class="detail-value">{{ displayValue(request?.customer?.SupportBankName) }}</span>
                    </div>
                    <div class="detail-field" *ngIf="request?.FKIDRequestType !== 5">
                        <span class="detail-label">BIC Banca di Appoggio</span>
                        <span class="detail-value">{{ displayValue(request?.customer?.SupportBankBIC) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Codice SDI</span>
                        <span class="detail-value">{{ displayValue(request?.customer?.SDICode) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">ULA Ultimo Bilancio</span>
                        <span class="detail-value">{{ displayValue(request?.customer?.ULALastBalance) }}</span>
                    </div>
                </div>

                <div class="detail-section">
                    <div class="detail-section-title">Dati Visura e Bilancio</div>
                    <div class="detail-field">
                        <span class="detail-label">Codice Fiscale</span>
                        <span class="detail-value">{{ displayValue(request?.customer?.FiscalCode) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Forma Giuridica</span>
                        <span class="detail-value">{{ displayValue(request?.customer?.LegalForm) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Codice ATECO</span>
                        <span class="detail-value">{{ displayValue(request?.customer?.AtecoCode) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Camera di Commercio</span>
                        <span class="detail-value">{{ displayValue(request?.customer?.ChamberOfCommerce) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Numero REA</span>
                        <span class="detail-value">{{ displayValue(request?.customer?.REANumber) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data Iscrizione</span>
                        <span class="detail-value">{{ request?.customer?.RegistrationDate ? (request?.customer?.RegistrationDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data Visura</span>
                        <span class="detail-value">{{ request?.customer?.VisuraDate ? (request?.customer?.VisuraDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Addetti</span>
                        <span class="detail-value">{{ displayValue(request?.customer?.Employees) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Domicilio Digitale (PEC)</span>
                        <span class="detail-value">{{ displayValue(request?.customer?.PEC) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data Bilancio</span>
                        <span class="detail-value">{{ request?.customer?.BalanceDate ? (request?.customer?.BalanceDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Ricavi Vendite e Prestazioni</span>
                        <span class="detail-value">{{ displayValue(request?.customer?.SalesRevenues) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Totale Attivo</span>
                        <span class="detail-value">{{ displayValue(request?.customer?.TotalAssets) }}</span>
                    </div>
                </div>

                <div class="detail-section">
                    <div class="detail-section-title">Legale Rappresentante</div>
                    <div class="detail-field">
                        <span class="detail-label">Nome</span>
                        <span class="detail-value">{{ displayValue(request?.customer?.Name) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Cognome</span>
                        <span class="detail-value">{{ displayValue(request?.customer?.Surname) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Luogo di Nascita</span>
                        <span class="detail-value">{{ displayPlace(request?.customer?.BirthPlace, request?.customer?.BirthPlaceProvince) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data di Nascita</span>
                        <span class="detail-value">{{ request?.customer?.BirthDate ? (request?.customer?.BirthDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Comune di Residenza</span>
                        <span class="detail-value">{{ displayPlace(request?.customer?.City, request?.customer?.Province) }}</span>
                    </div>
                </div>

                <div class="detail-section">
                    <div class="detail-section-title">Contatti</div>
                    <div class="detail-field">
                        <span class="detail-label">E-mail Cliente</span>
                        <span class="detail-value">{{ displayValue(request?.customer?.Email) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Telefono Fisso</span>
                        <span class="detail-value">{{ displayValue(request?.customer?.Phone) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Telefono Cellulare</span>
                        <span class="detail-value">{{ displayValue(request?.customer?.MobilePhone) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-5 col-12" *ngIf="activeView === 'base'">
        <div class="panel">
            <div class="panel-header panel-controls bg-dark">
                <h3><i class="fa fa-list"></i>Dati <strong>Pratica</strong></h3>
            </div>
            <div class="panel-content detail-panel">
                <div class="detail-section">
                    <div class="detail-section-title">Investimento</div>
                    <div class="detail-field">
                        <span class="detail-label">Società Partecipata</span>
                        <span class="detail-value">{{ displayBoolean(request?.CompanyParticipation) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Soci Partecipanti</span>
                        <span class="detail-value">{{ displayBoolean(request?.PartnersParticipation) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Modalità Investimento</span>
                        <span class="detail-value">{{ displayValue(request?.InvestmentMode) }}</span>
                    </div>
                    <div class="detail-field" *ngIf="showLeasingFields">
                        <span class="detail-label">Società di Leasing Finanziatrice</span>
                        <span class="detail-value">{{ displayValue(request?.LeasingCompanyName) }}</span>
                    </div>
                    <div class="detail-field" *ngIf="showLeasingFields">
                        <span class="detail-label">Durata Leasing/Finanziamento</span>
                        <span class="detail-value">{{ investmentDurationDisplay }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Sede Operativa</span>
                        <span class="detail-value">{{ operationalHeadquartersDisplay }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Agevolazioni</span>
                        <span class="detail-value">{{ displayBoolean(request?.Concessions) }}</span>
                    </div>
                    <div class="detail-field detail-field-block" *ngIf="request?.Concessions">
                        <span class="detail-label">Specifica Agevolazioni</span>
                        <span class="detail-value">{{ displayValue(request?.ConcessionsDetails) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Importo Totale Investimento</span>
                        <span class="detail-value detail-value-money">{{ investmentAmountDisplay }}</span>
                    </div>
                    <div class="detail-field" *ngIf="showSingleDepreciationRate">
                        <span class="detail-label">Aliquota di ammortamento</span>
                        <span class="detail-value">{{ request?.DepreciationRate | number:'1.0-2':'it-IT' }}%</span>
                    </div>
                    <div class="detail-field detail-field-block" *ngIf="showMultipleDepreciationAssets">
                        <span class="detail-label">Aliquote di ammortamento</span>
                        <span class="detail-value">
                            <span class="depreciation-asset-item" *ngFor="let asset of parsedDepreciationAssets">
                                {{ displayValue(asset.description) }}: {{ asset.rate != null ? (asset.rate | number:'1.0-2':'it-IT') + '%' : '-' }}
                            </span>
                        </span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Codice ATECO</span>
                        <span class="detail-value">{{ displayValue(request?.AtecoCode) }}</span>
                    </div>
                    <div class="detail-field" *ngIf="request.FKIDRequestType !== 5 && request?.InvestmentType !== 'Nessuno'">
                        <span class="detail-label">Tipologia Investimento</span>
                        <span class="detail-value">{{ displayValue(request?.InvestmentType) }}</span>
                    </div>
                    <div class="detail-field" *ngIf="request.FKIDRequestType !== 5">
                        <span class="detail-label">Ampliamento Aziendale</span>
                        <span class="detail-value">{{ displayBoolean(request?.BusinessExpansion) }}</span>
                    </div>
                    <div class="detail-field" *ngIf="request.FKIDRequestType === 5">
                        <span class="detail-label">Scopo Investimento</span>
                        <span class="detail-value">{{ displayValue(request?.TaxCredit5BusinessExpansion) }}</span>
                    </div>
                </div>

                <div class="detail-section" *ngIf="isRequestType67">
                    <div class="detail-section-title">Dati catastali</div>
                    <div class="detail-field">
                        <span class="detail-label">Codice Catastale</span>
                        <span class="detail-value">{{ displayValue(request?.TaxCredit5CadastralCode) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Sezione</span>
                        <span class="detail-value">{{ displayValue(request?.TaxCredit5CadastralSection) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Foglio</span>
                        <span class="detail-value">{{ displayValue(request?.TaxCredit5CadastralSheet) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Particella</span>
                        <span class="detail-value">{{ displayValue(request?.TaxCredit5CadastralParticle) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Sub</span>
                        <span class="detail-value">{{ displayValue(request?.TaxCredit5CadastralSub) }}</span>
                    </div>
                </div>

                <div class="detail-section" *ngIf="checkRequest4">
                    <div class="detail-section-title">Credito d'imposta 4.0</div>
                    <div class="detail-field">
                        <span class="detail-label">Compensazione in 3 anni (2025-2026-2027)</span>
                        <span class="detail-value">{{ displayBoolean(request?.TaxCredit4Years) }}</span>
                    </div>
                    <div class="detail-field" *ngIf="request?.TaxCredit4Years === false">
                        <span class="detail-label">Anni di Compensazione (dettaglio)</span>
                        <span class="detail-value">{{ displayValue(request?.TaxCredit4YearsCompensation) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data Presunta di Avvio</span>
                        <span class="detail-value">{{ request?.TaxCredit4StartDate ? (request?.TaxCredit4StartDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data Presunta di Conclusione</span>
                        <span class="detail-value">{{ request?.TaxCredit4EndDate ? (request?.TaxCredit4EndDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                </div>

                <div class="detail-section" *ngIf="isRequestType67">
                    <div class="detail-section-title">Credito d'imposta 5.0</div>
                    <div class="detail-field">
                        <span class="detail-label">Rispetto Normative</span>
                        <span class="detail-value">{{ displayBoolean(request?.TaxCredit5Regulations) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Revisore Legale Conti</span>
                        <span class="detail-value">{{ displayBoolean(request?.TaxCredit5Revisor) }}</span>
                    </div>
                    <div class="detail-field" *ngIf="request?.TaxCredit5Revisor">
                        <span class="detail-label">E-mail Revisore Legale</span>
                        <span class="detail-value">{{ displayValue(request?.TaxCredit5RevisorEmail) }}</span>
                    </div>
                    <div class="detail-field" *ngIf="request?.TaxCredit5Revisor">
                        <span class="detail-label">Telefono Revisore Legale</span>
                        <span class="detail-value">{{ displayValue(request?.TaxCredit5RevisorPhone) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data Presunta di Conclusione</span>
                        <span class="detail-value">{{ request?.TaxCredit5EndDate ? (request?.TaxCredit5EndDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                </div>

                <div class="detail-section">
                    <div class="detail-section-title">Dati Sottofase 1</div>
                    <div class="detail-field">
                        <span class="detail-label">Marca da Bollo</span>
                        <span class="detail-value">{{ displayValue(request?.RevenueStamp) }}</span>
                    </div>
                    <div class="detail-field" [class.detail-field-block]="request?.Notes">
                        <span class="detail-label">Note</span>
                        <span class="detail-value">{{ displayValue(request?.Notes) }}</span>
                    </div>
                </div>

                <div class="detail-section">
                    <div class="detail-section-title">Dati Sottofase 2</div>
                    <div class="detail-field">
                        <span class="detail-label">Codice CUP</span>
                        <span class="detail-value">{{ displayValue(request?.CUPCode) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data Invio Codice CUP PEC</span>
                        <span class="detail-value">{{ request?.CUPCodePECSentDate ? (request?.CUPCodePECSentDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data Invio Codice CUP E-mail</span>
                        <span class="detail-value">{{ request?.CUPCodeEmailSentDate ? (request?.CUPCodeEmailSentDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                </div>

                <div class="detail-section">
                    <div class="detail-section-title">Dati Fase 2</div>
                    <div class="detail-field">
                        <span class="detail-label">Codice Identificativo Decreto</span>
                        <span class="detail-value">{{ displayValue(request?.DecreeIdentificationCode) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Stato RU</span>
                        <span class="detail-value">{{ displayBoolean(request?.RUStatus) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data Invio E-mail Fornitore Liberatoria</span>
                        <span class="detail-value">{{ request?.SupplierReleaseEmailSentDate ? (request?.SupplierReleaseEmailSentDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Controllo Documenti</span>
                        <span class="detail-value">{{ displayValue(request?.DocumentsCheck) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data di Avvio</span>
                        <span class="detail-value">{{ displayValue(request?.StartDateStatus) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">RU in Cartella</span>
                        <span class="detail-value">{{ displayBoolean(request?.RUInFolder) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">RU Trasmesso</span>
                        <span class="detail-value">{{ request?.RUTransmittedDate ? (request?.RUTransmittedDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Contributo Sabatini</span>
                        <span class="detail-value">{{ request?.SabatiniContribution ? (request?.SabatiniContribution + ' euro') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Richiesta Pagamento 2</span>
                        <span class="detail-value">{{ request?.PaymentRequest2Date ? (request?.PaymentRequest2Date | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Richiesta Pagamento 3</span>
                        <span class="detail-value">{{ request?.PaymentRequest3Date ? (request?.PaymentRequest3Date | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Richiesta Pagamento 4</span>
                        <span class="detail-value">{{ request?.PaymentRequest4Date ? (request?.PaymentRequest4Date | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Richiesta Pagamento 5</span>
                        <span class="detail-value">{{ request?.PaymentRequest5Date ? (request?.PaymentRequest5Date | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Richiesta Pagamento 6</span>
                        <span class="detail-value">{{ request?.PaymentRequest6Date ? (request?.PaymentRequest6Date | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field" [class.detail-field-block]="request?.NotesPhase2">
                        <span class="detail-label">Note Fase 2</span>
                        <span class="detail-value">{{ displayValue(request?.NotesPhase2) }}</span>
                    </div>
                </div>

                <div class="detail-section">
                    <div class="detail-section-title">Dati Fase Preventiva</div>
                    <div class="detail-field">
                        <span class="detail-label">Data Invio File Preventiva Cliente</span>
                        <span class="detail-value">{{ request?.PreventiveFileClientSentDate ? (request?.PreventiveFileClientSentDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data Invio Preventiva</span>
                        <span class="detail-value">{{ request?.PreventiveSentDate ? (request?.PreventiveSentDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data Ricevuta Preventiva</span>
                        <span class="detail-value">{{ request?.PreventiveReceiptDate ? (request?.PreventiveReceiptDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">E-mail Cliente Fornitore Preventiva</span>
                        <span class="detail-value">{{ request?.PreventiveClientSupplierEmailDate ? (request?.PreventiveClientSupplierEmailDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Codice Preventiva</span>
                        <span class="detail-value">{{ displayValue(request?.PreventiveCode) }}</span>
                    </div>
                </div>

                <div class="detail-section">
                    <div class="detail-section-title">Dati Fase Intermedia</div>
                    <div class="detail-field">
                        <span class="detail-label">Copia Fattura Acconto</span>
                        <span class="detail-value">{{ displayValue(request?.AdvanceInvoiceCopy) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Copia Distinta Acconto</span>
                        <span class="detail-value">{{ displayValue(request?.AdvanceSlipCopy) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Invio File Intermedia Cliente</span>
                        <span class="detail-value">{{ displayValue(request?.IntermediateFileClientSent) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data Invio Intermedia</span>
                        <span class="detail-value">{{ request?.IntermediateSentDate ? (request?.IntermediateSentDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data Ricevuta Intermedia</span>
                        <span class="detail-value">{{ request?.IntermediateReceiptDate ? (request?.IntermediateReceiptDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Stipula Leasing</span>
                        <span class="detail-value">{{ displayValue(request?.LeasingStipulation) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Codice Intermedia</span>
                        <span class="detail-value">{{ displayValue(request?.IntermediateCode) }}</span>
                    </div>
                </div>

                <div class="detail-section">
                    <div class="detail-section-title">Dati Fase Completamento</div>
                    <div class="detail-field">
                        <span class="detail-label">Data Invio E-mail Richiesta Doc</span>
                        <span class="detail-value">{{ request?.DocumentRequestEmailSentDate ? (request?.DocumentRequestEmailSentDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Certificazione Revisore</span>
                        <span class="detail-value">{{ displayValue(request?.AuditorCertification) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data Invio File da Firmare al Cliente</span>
                        <span class="detail-value">{{ request?.SigningFileClientSentDate ? (request?.SigningFileClientSentDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data Invio Completamento</span>
                        <span class="detail-value">{{ request?.CompletionSentDate ? (request?.CompletionSentDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data Ricevuta Completamento</span>
                        <span class="detail-value">{{ request?.CompletionReceiptDate ? (request?.CompletionReceiptDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Codice Completamento</span>
                        <span class="detail-value">{{ displayValue(request?.CompletionCode) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Perizia 4.0</span>
                        <span class="detail-value">{{ displayValue(request?.Expertise40) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Perito</span>
                        <span class="detail-value">{{ displayValue(request?.Expert) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">E-mail Perito</span>
                        <span class="detail-value">{{ displayValue(request?.ExpertEmail) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Sicurezza sul Lavoro</span>
                        <span class="detail-value">{{ displayBoolean(request?.WorkplaceSafety) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Importo Percentuale Agevolazione</span>
                        <span class="detail-value">{{ displayValue(request?.IncentivePercentageAmount) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Pagamento Acconto</span>
                        <span class="detail-value">{{ displayValue(request?.AdvancePayment) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data Conferma Credito</span>
                        <span class="detail-value">{{ request?.CreditConfirmationDate ? (request?.CreditConfirmationDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data Finalizzazione Fase 1</span>
                        <span class="detail-value">{{ request?.Phase1FinalizationDate ? (request?.Phase1FinalizationDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel" *ngIf="user.FKIDUserRole === 1">
            <div class="panel-header panel-controls bg-dark">
                <h3><i class="fa fa-comment-o"></i><strong>Note</strong></h3>
            </div>
            <div class="panel-content">
                <app-request-notes #requestNotes [idRequest]="request.IDRequest"></app-request-notes>
            </div>
            <div class="panel-footer">
                <button type="button"
                        class="btn btn-sm btn-primary"
                        (click)="requestNotes.openCreateNoteModal()"
                        [disabled]="requestNotes.creating">
                    <i class="fa fa-plus"></i>Aggiungi nota
                </button>
            </div>
        </div>
    </div>
    <div class="col-md-10 col-12" style="margin-bottom: 100px;" *ngIf="activeView === 'base'">
        <div class="panel">
            <div class="panel-header panel-controls bg-dark">
                <h3><i class="fa fa-file"></i> <strong>Documentazione</strong></h3>
            </div>
            <div class="panel-content">
                <div class="table-scroll">
                    <table *ngIf="documents.length > 0" class="table table-hover table-historical">
                        <thead>
                        <tr>
                            <th>Nome File</th>
                            <th>Tipologia</th>
                            <th class="text-right col-sticky col-sticky-actions">Azioni</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let currentDocument of documents">
                            <td>{{ currentDocument.Path }}</td>
                            <td>{{ documentTypes[currentDocument.FKIDDocumentType!] }}</td>
                            <td class="text-right col-sticky col-sticky-actions">
                                <a (click)="previewDocument(currentDocument)" class="edit btn btn-sm doc-preview-btn" title="Anteprima" aria-label="Anteprima"><i class="fa fa-eye"></i></a>
                                <a (click)="downloadDocument(currentDocument)" class="edit btn btn-sm btn-success" title="Download" aria-label="Download"><i class="fa fa-download"></i></a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="documents.length === 0" class="detail-empty-docs">
                    Nessun documento caricato.
                </div>
            </div>
        </div>
    </div>
</div>
